import { Injectable } from '@angular/core';
import { PlanMainService } from '../../service/plan-main.service';

@Injectable()
export class PlanLoanMain {
  public creditCompany1: any;
  public creditCompany2: any;
  public creditCompany3: any;

  public loanPlan1: any;
  public loanPlan2: any;
  public loanPlan3: any;
  constructor(private _planMainservice: PlanMainService) {}

  /// CreditCompany /////
  setchosenCreditCompany(value) {
    if (this._planMainservice.getstatusGradeCar() === 1) {
      this.creditCompany1 = value;
    } else if (this._planMainservice.getstatusGradeCar() === 2) {
      this.creditCompany2 = value;
    } else if (this._planMainservice.getstatusGradeCar() === 3) {
      this.creditCompany3 = value;
    }
  }
  getCreditCompany1() {
    return this.creditCompany1;
  }
  getCreditCompany2() {
    return this.creditCompany2;
  }
  getCreditCompany3() {
    return this.creditCompany3;
  }

  /// LoanPlan  /////
  setchosenLoanPlan(value) {
    if (this._planMainservice.getstatusGradeCar() === 1) {
      this.loanPlan1 = value;
    } else if (this._planMainservice.getstatusGradeCar() === 2) {
      this.loanPlan2 = value;
    } else if (this._planMainservice.getstatusGradeCar() === 3) {
      this.loanPlan3 = value;
    }
  }

  getLoanPlan1() {
    return this.loanPlan1;
  }
  getLoanPlan2() {
    return this.loanPlan2;
  }
  getLoanPlan3() {
    return this.loanPlan3;
  }
}



// WEBPACK FOOTER //
// ./src/app/plan/planone/services/planloanmain.service.ts